function Menu(){

    var self = this;

    self.browserSize = new BrowserSize();

    $('#show-menu').click(function(e) {

        console.log("show menu clicked");

        if ($('#nav').hasClass('open')) {

            $('#nav').removeClass('open');

        } else {

            $('.sub-menu').removeClass("sub-open");
            $('#nav').addClass('open');
        }

    });

    self.animating = false;

    $('.menu-item a').click(function(e) {

        //e.preventDefault();

        if($(this).parent().hasClass("menu-item-has-children")){

            e.preventDefault();

            console.log("item has children");

            if($(this).parent().parent().parent().hasClass("menu-item-has-children")){

                console.log("is second level sub menu");

                var $link = $(this);

                // TweenMax.killChildTweensOf(document.getElementById("nav"));

                function closed() {

                    $link.siblings('.sub-menu').removeClass("sub-open");
                }

                if ($link.siblings('.sub-menu').hasClass('sub-open')) {
                    $link.removeClass("selected");
                    //$link.siblings('.sub-menu').removeClass("sub-open");

                    $subMenu = $link.siblings('.sub-menu');
                    $subMenuItem = $('.menu-item', $subMenu);

                    TweenMax.set($subMenu, {height: "auto"});
                    TweenMax.to($subMenu, 0.7, {height: 0, delay: 0.4, ease: Sine.easeInOut, onComplete: closed});

                    TweenMax.to($subMenuItem, 0.4, {autoAlpha: 0});


                } else {


                    $link.addClass("selected");
                    $link.siblings('.sub-menu').addClass("sub-open");

                    $subMenu = $link.siblings('.sub-menu');
                    $subMenuItem = $('.menu-item', $subMenu);

                    TweenMax.set($subMenu, {height: "auto"});
                    TweenMax.from($subMenu, 0.7, {height: 0, ease: Sine.easeInOut});

                    self.browserSize.getWindowSize();

                    var x = self.browserSize.width / 20;

                    TweenMax.set($subMenuItem, {x: -x, autoAlpha: 0});
                    TweenMax.staggerTo($subMenuItem, 0.75, {autoAlpha: 1, x: 0, ease: Sine.easeOut, delay: 0.4}, 0.25);
                }


            } else {

                var $link = $(this);

                // TweenMax.killChildTweensOf(document.getElementById("nav"));

                function closed() {

                    $link.siblings('.sub-menu').removeClass("sub-open");
                }

                if ($link.siblings('.sub-menu').hasClass('sub-open')) {
                    $link.removeClass("selected");
                    //$link.siblings('.sub-menu').removeClass("sub-open");

                    $subMenu = $link.siblings('.sub-menu');
                    $subMenuItem = $('.menu-item', $subMenu);

                    TweenMax.set($subMenu, {height: "auto"});
                    TweenMax.to($subMenu, 0.7, {height: 0, delay: 0.4, ease: Sine.easeInOut, onComplete: closed});

                    TweenMax.to($subMenuItem, 0.4, {autoAlpha: 0});


                } else {


                    $link.addClass("selected");
                    $link.siblings('.sub-menu').addClass("sub-open");

                    $subMenu = $link.siblings('.sub-menu');
                    $subMenuItem = $('.menu-item', $subMenu);

                    TweenMax.set($subMenu, {height: "auto"});
                    TweenMax.from($subMenu, 0.7, {height: 0, ease: Sine.easeInOut});

                    self.browserSize.getWindowSize();

                    var x = self.browserSize.width / 20;

                    TweenMax.set($subMenuItem, {x: -x, autoAlpha: 0});
                    TweenMax.staggerTo($subMenuItem, 0.75, {autoAlpha: 1, x: 0, ease: Sine.easeOut, delay: 0.4}, 0.25);
                }
            }


        } else {

            console.log("------------------ item has no children");

            var current = window.location.href;

            var linkURL = $(this).attr("href");

            // add class current-menu-item

            if (current === linkURL){

                e.preventDefault();
                $('#nav').removeClass('open');

            } else {

                console.log("------------------ set current");

                $('#menu-wrapper li').removeClass("current-menu-item");

                $(this).parent().addClass("current-menu-item");
            }

            console.log("linkURL " + linkURL);

        }

    });

};
